import React, { FC, Fragment, useEffect, useState } from "react";
import { ExternalChatChannel, ExternalChatOrganization, ExternalChatUserState, } from "domain-entities";
import SidebarView from "Components/Layout/SidebarView";
import ContentView from "Components/Layout/ContentView";
import ChannelsView from "./ChannelsView";
import { useReadChannel } from "Components/UserState/UserStateHelper";
import { SaveDocumentStore } from "Helpers/StoreHelper";
import MessagesView from "Components/Message/MessagesView";
import { useChannelsStore } from "./ChannelsStore";
import { useViewer } from "Components/Auth/AuthProvider";
import { useUsersStore } from "Components/User/UsersStore";
import { useUserStatusesOnceStore } from "Components/UserStatus/UserStatusesOnceStore";
import { getExternalActiveUserIds } from "Components/User/UserHelper";

interface Props {
  organization: ExternalChatOrganization;
  viewerUserStateStore: SaveDocumentStore<ExternalChatUserState>;
  onClose: () => void;
}

const ChannelsPage: FC<Props> = (props) => {
  const viewer = useViewer();
  const [selectedChannel, setSelectedChannel] = useState<ExternalChatChannel>();
  const readChannel = useReadChannel(props.viewerUserStateStore);
  const channelsStore = useChannelsStore(props.organization.id);
  const viewerUsersStore = useUsersStore(
    props.organization.id,
    viewer.user.uid
  );

  const viewerUser = viewerUsersStore.items.length
    ? viewerUsersStore.items[0]
    : undefined;

  const userStatusesOnceStore = useUserStatusesOnceStore(
    props.organization.id,
    getExternalActiveUserIds(channelsStore)
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (selectedChannel) {
        readChannel(props.organization, selectedChannel);
      }
    }, READ_CHANNEL_TIMEOUT);

    return () => clearTimeout(timeout);
  }, [readChannel, props.organization, selectedChannel]);

  function renderMessagesView() {
    if (selectedChannel && viewerUser) {
      return (
        <MessagesView
          key={selectedChannel.id}
          organization={props.organization}
          channel={selectedChannel}
          viewerUser={viewerUser}
          readChannel={() => readChannel(props.organization, selectedChannel)}
        />
      );
    }
  }

  return (
    <Fragment>
      <SidebarView>
        <ChannelsView
            organization={props.organization}
            viewerUserState={props.viewerUserStateStore.item}
            channelsStore={channelsStore}
            userStatusesOnceStore={userStatusesOnceStore}
            onClose={props.onClose}
            setSelectedChannel={setSelectedChannel}
            selectedChannelId={selectedChannel?.id}
        />
      </SidebarView>
      <ContentView>{renderMessagesView()}</ContentView>
    </Fragment>
  );
};

export default ChannelsPage;

const READ_CHANNEL_TIMEOUT = 4000;
